import { TutorialStep, version } from 'src/replicant/tutorial/tutorial.ruleset';
import { TutorialEvent } from '../TutorialController';
import OrdinaryTutorial from './OrdinaryTutorial';
import StateObserver from 'src/StateObserver';
import { openPopupPromise } from 'src/lib/popups/popupOpenClose';
import { completeTutorialStep } from '../tutorial.util';
import { analytics } from '@play-co/gcinstant';

export class EncyclopediaTutorial extends OrdinaryTutorial {
  public readonly step: TutorialStep = 'encyclopedia';
  private startTime: number = StateObserver.now();

  public async handleEvent(event: TutorialEvent): Promise<boolean> {
    // After the first evolution
    if (event !== 'encyclopediaOpenedAfterEvolution') {
      return false;
    }

    const analyticsProps = {
      stepIndex: 29,
      stepName: 'encyclopedia',
      tutorialKey: version,
    };

    // Send before open popup
    analytics.game.tutorial.TutorialStart(analyticsProps);

    // Open custom tutorial popup
    await openPopupPromise('popupEncyclopediaTutorial', {
      step: 'encyclopedia',
    });

    // Run complete tutorial sequence
    await completeTutorialStep('encyclopedia', {
      $stepIndex: analyticsProps.stepIndex,
      $stepName: analyticsProps.stepName,
    });

    return true;
  }
}
